const fontWeightBold = 'var(--fontWeightBold, 700)'
import styled from 'astroturf/react'
import { BareButton } from '@calendly/ui/components/bare-button'
import _SpotButton from "SpotButton.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/select_date_time/spot_button.js?styleId=SpotButton";


export const SpotButton = /*#__PURE__*/styled(BareButton, null, {
  displayName: "SpotButton",
  styles: _SpotButton
})
